import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useIsAuthenticatedUser } from '@/utils';
import { ROUTE_PATHS } from '@/router/constants';
import { getRoleHomePath } from '@/router/roles';

export const RedirectHandler = () => {
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticatedUser();
  const currentUser = useSelector((state) => state?.currentUser?.currentUser);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ROUTE_PATHS.LOGIN);
      return;
    }
    navigate(getRoleHomePath(currentUser), { replace: true });
  }, [isAuthenticated, currentUser, navigate]);

  return null;
};
